import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventWhistleOvertimeStopSecondHalftime extends DomainEvent<MatchEvent> {}
